"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default=function(e){for(var r in e)if(e.hasOwnProperty(r))return!1;return!0};
